import { render } from "./Windchill.vue?vue&type=template&id=80337304&scoped=true"
import script from "./Windchill.vue?vue&type=script&lang=js"
export * from "./Windchill.vue?vue&type=script&lang=js"

import "./Windchill.vue?vue&type=style&index=0&id=80337304&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Administrateur\\Documents\\davca-cm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80337304"]])

export default __exports__